import React from "react";
import { Package, Search, RefreshCw } from "lucide-react";

const EmptyState = ({
  type = "no-products",
  title,
  description,
  actionText,
  onAction,
  icon: CustomIcon,
}) => {
  const getEmptyStateConfig = () => {
    switch (type) {
      case "no-products":
        return {
          icon: Package,
          title: title || "No Products Available",
          description:
            description ||
            "There are currently no products in our catalog. Check back soon for new arrivals!",
          actionText: actionText || "Add Sample Products",
          bgColor: "bg-blue-50",
          iconColor: "text-blue-400",
          textColor: "text-blue-600",
        };
      case "no-search-results":
        return {
          icon: Search,
          title: title || "No Products Found",
          description:
            description ||
            "We couldn't find any products matching your search criteria. Try adjusting your filters or search terms.",
          actionText: actionText || "Clear Filters",
          bgColor: "bg-gray-50",
          iconColor: "text-gray-400",
          textColor: "text-gray-600",
        };
      case "empty-cart":
        return {
          icon: Package,
          title: title || "Your Cart is Empty",
          description:
            description || "Add some products to your cart to get started.",
          actionText: actionText || "Continue Shopping",
          bgColor: "bg-green-50",
          iconColor: "text-green-400",
          textColor: "text-green-600",
        };
      case "error":
        return {
          icon: RefreshCw,
          title: title || "Something Went Wrong",
          description:
            description ||
            "We encountered an error while loading the products. Please try again.",
          actionText: actionText || "Try Again",
          bgColor: "bg-red-50",
          iconColor: "text-red-400",
          textColor: "text-red-600",
        };
      default:
        return {
          icon: Package,
          title: title || "Nothing Here",
          description: description || "There's nothing to show at the moment.",
          actionText: actionText || "Go Back",
          bgColor: "bg-gray-50",
          iconColor: "text-gray-400",
          textColor: "text-gray-600",
        };
    }
  };

  const config = getEmptyStateConfig();
  const IconComponent = CustomIcon || config.icon;

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="mb-6">
        <span className="inline-block bg-primary-100 rounded-full p-5 shadow">
          <IconComponent className={`h-12 w-12 ${config.iconColor}`} />
        </span>
      </div>
      <h2 className="text-2xl font-bold text-primary-700 mb-2">
        {config.title}
      </h2>
      <p className="text-secondary-600 mb-6">{config.description}</p>
      {onAction && (
        <button
          onClick={onAction}
          className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-lg shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
        >
          {config.actionText}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
